import { createMemoryRouter, RouteObject } from 'react-router-dom'

import { JourneyRouterContext } from '@cash-web/shared-journey-util-main'

type MemoryRouterOptions = Parameters<typeof createMemoryRouter>[1]

function wrapLoader(loader: RouteObject['loader'], context: JourneyRouterContext): RouteObject['loader'] {
  if (typeof loader === 'function') {
    return args => loader({ ...args, context })
  }
  return loader
}

function transformRoutes(routes: RouteObject[], context: JourneyRouterContext): RouteObject[] {
  return routes.map(({ loader, children, index, ...route }) => {
    if (index) {
      return {
        ...route,
        index: true,
        loader: wrapLoader(loader, context),
      }
    }

    return {
      ...route,
      loader: wrapLoader(loader, context),
      children: children ? transformRoutes(children, context) : undefined,
    }
  })
}

export function createMemoryRouterWithContext(
  routes: RouteObject[],
  opts: MemoryRouterOptions,
  context: JourneyRouterContext
) {
  const transformedRoutes = transformRoutes(routes, context)
  return createMemoryRouter(transformedRoutes, opts)
}
